export default __webpack_public_path__ + "static/media/crust.034f41df.png";